export default __webpack_public_path__ + "static/media/2007.7248ccad.png";